import TeamStandings from "src/pages/[league]/team-standings/index.jsx";
import { useRouter } from "next/router";

const ConferenceStandings = () => {
  const router = useRouter();
  const conference = router.query?.conference;
  return <TeamStandings conference={conference} />;
};

export default ConferenceStandings;
